module.exports = __webpack_public_path__ + "static/media/2.e4ad5717.jpg";